export default __webpack_public_path__ + "static/media/targetReview.b9961014.svg";